<template>
  <motlet :options="motletOptions">
    <template #content="{ props }">
      <!-- eslint-disable-next-line prettier/prettier -->
      <line-double-stack
        :system="system"
        :items="nodes"
        :values="values"
        :split="split"
        :y-axis-names="yAxisNames"
        :tooltip-contents="tooltipContents"
        :motlet="props.motlet"
      />
    </template>
  </motlet>
</template>

<script>
import { clone } from 'lodash';
import { parse, format } from 'date-fns';
import instanceable from './mixins/instanceable';
import LineDoubleStack from '../chart/LineDoubleStack.vue';
import { api } from '../../../../api/common/instances';

export default {
  mixins: [instanceable],
  components: {
    LineDoubleStack,
  },
  data() {
    return {
      motletOptions: {
        id: 'overview/system/java/ThroughputLine',
        title: 'Throughput',
        zoom: {
          use: true,
          active: false,
        },
      },
      messageNames: ['rawJavaWorkload'],
      messageFields: ['stime', 'totStep', 'avgRespti'],
      dataInterval: 30 * 1000, // db data 시간 간격
      values: [],
      split: {},
      splits: {},
      recieve: {},
      yAxisNames: ['totStep', 'avgRespti'],
      tooltipContents: [{ column: 'totStep' }],
    };
  },
  watch: {
    nodes: {
      handler: 'changeNodesHandler',
    },
  },
  methods: {
    // BEGIN:: Removed.by.KWShin.2025.11.18.
    // wsBufferedDataHandler(key, responses, every) {
    //   responses.forEach(response => {
    //     const last = response.length ? response[response.length - 1] : { data: [], ctime: '', empty: true };
    //     every(key, last.data, last.ctime, last.empty);
    //   });
    // },
    // FINISH:: Removed.by.KWShin.2025.11.18.
    wsDataHandler(key, response, ctime, empty) {
      if (!response.length) {
        const stime = new Date().getTime();
        response = [
          {
            ctime: stime,
            stime,
          },
        ];
      }
      // 1. 그룹 별 첫번째 message 수신의 경우 값 초기화
      if (key.name == this.messageNames[0]) {
        const stime = parseInt(response[0].stime);
        this.splits[key.instId + key.nodeId] = {
          id: key.instId + key.nodeId,
          ctime: parseInt(ctime),
          stime: stime - (stime % this.dataInterval), // db 데이터 간격 기준으로 실시간 데이터를 근사값으로 보정
          totStep: 0,
        };
      }

      // 2. 그룹별 데이터 누적처리
      if (!empty) response.forEach(res => (this.splits[key.instId + key.nodeId].totStep += parseInt(res.totStep)));

      // 3. 그룹 별 마지막 message 수신의 경우 처리
      if (key.name == this.messageNames[this.messageNames.length - 1]) {
        this.split = clone(this.splits[key.instId + key.nodeId]);
      }
    },
    sendMessage() {
      this.$websocket.realtime.send({
        requests: this.nodes.reduce(
          (acc, node) =>
            acc.concat(
              this.messageNames.map(name => ({
                key: { name: name, sstmId: node.systemId, instId: node.instanceId, nodeId: node.id },
                fields: this.messageFields,
                handler: {
                  // buffer: this.wsBufferedDataHandler,
                  every: this.wsDataHandler,
                },
              })),
            ),
          [],
        ),
      });
    },
    async allDay() {
      const beginYmdhms = parse(`${format(new Date(), 'yyyyMMdd')}000000`, 'yyyyMMddHHmmss', new Date()).getTime();
      const endYmdhms = parse(`${format(new Date(), 'yyyyMMdd')}235959`, 'yyyyMMddHHmmss', new Date()).getTime();
      const { data } = await api.get('/motlet-data/chart/day-all', {
        params: {
          sstmId: this.system.id,
          motletCode: 'C_JAVA_THROUGHPUT',
          beginYmdhms,
          endYmdhms,
        },
      });
      this.values = data.map(value => ({
        id: value.key.instId + value.key.nodeId,
        left: value.data,
        right: value.yesterData,
      }));
    },
    initialize() {
      // websoket message init
      this.wsRequestMessages = {};
    },
    changeNodesHandler() {
      this.initialize();
      this.sendMessage();
      this.allDay();
    },
  },
};
</script>
